import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'

import {useUtils} from '../../hooks/useUtils.js'
import {PanelFinancingCalculator} from './PanelFinancingCalculator.js'
import {PanelFinancingInstalment} from './PanelFinancingInstalment.js'

const BASE_CLASS = 'mt-PanelFinancing'

export const PanelFinancingInstalmentSection = ({
  entryErrorText = '',
  entryValue,
  handleEntryChange,
  handleOnBlurEntry,
  handleOnChangeSelectedFare = () => {},
  handleTermsChange,
  hasInputError,
  isProfessional,
  loanCalculations,
  loanCalculationsError = '',
  selectedTerms,
  selectedFare = false,
  selectedFareData = {}
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const {getPanelFinancingVersion} = useUtils()

  const {
    ERRORS: {TransactionError}
  } = config.get('COMMON')

  const isGenericErrorLoanCalculation = loanCalculationsError instanceof TransactionError

  const panelFinancingVersion = getPanelFinancingVersion({isProfessional, loanCalculations})

  return (
    <div className={`${BASE_CLASS}-instalmentSection`}>
      <PanelFinancingCalculator
        entryErrorText={entryErrorText}
        entryValue={entryValue}
        handleEntryChange={handleEntryChange}
        handleOnBlurEntry={handleOnBlurEntry}
        handleTermsChange={handleTermsChange}
        hasInputError={hasInputError}
        isProfessional={isProfessional}
        loanCalculations={loanCalculations}
        loanCalculationsError={loanCalculationsError}
        selectedFareData={selectedFareData}
        selectedTerms={selectedTerms}
      />
      <PanelFinancingInstalment
        handleOnChangeSelectedFare={handleOnChangeSelectedFare}
        isProfessional={isProfessional}
        loanCalculations={loanCalculations}
        panelFinancingVersion={panelFinancingVersion}
        selectedFare={selectedFare}
      />
      {isProfessional && isGenericErrorLoanCalculation && (
        <div className={`${BASE_CLASS}-footerErrorB2c`}>{i18n.t('COMMON.SERVICE_DOWN_TRY_LATER')}</div>
      )}
    </div>
  )
}

PanelFinancingInstalmentSection.propTypes = {
  isProfessional: PropTypes.string,
  entryErrorText: PropTypes.string,
  entryValue: PropTypes.number,
  handleEntryChange: PropTypes.func,
  handleTermsChange: PropTypes.func,
  handleOnBlurEntry: PropTypes.func,
  handleOnChangeSelectedFare: PropTypes.func,
  hasInputError: PropTypes.bool,
  loanCalculations: PropTypes.object,
  loanCalculationsError: PropTypes.string,
  selectedTerms: PropTypes.string,
  selectedFare: PropTypes.bool,
  selectedFareData: PropTypes.object
}
